import React, { useEffect, useRef } from "react";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
	TextField
} from "@material-ui/core";
import { AiSparkleIcon } from "../../../Shared/AiSparkleIcon";
import { Spinner } from "../../../Shared/Spinner";

function OptimizeRecipeModal({ isOpen, instructions, onInstructionsChange, streamOutput, isStreaming, onSubmit, onCancel, isExecuting }) {
	const streamRef = useRef(null);

	useEffect(() => {
		if (streamRef.current) {
			streamRef.current.scrollTop = streamRef.current.scrollHeight;
		}
	}, [streamOutput]);

	return (
		<Dialog open={isOpen} onClose={onCancel} fullWidth maxWidth="sm">
			<DialogTitle>Optimize Recipe</DialogTitle>
			<DialogContent>
				{isStreaming ? (
					<React.Fragment>
						<Typography gutterBottom>AI stream</Typography>
						<TextField
							fullWidth
							multiline
							rows={8}
							variant="outlined"
							value={streamOutput}
							inputRef={streamRef}
							InputProps={{ readOnly: true }}
						/>
					</React.Fragment>
				) : (
					<React.Fragment>
						<Typography gutterBottom>
							Add any optional guidance for the AI to apply while optimizing this recipe.
						</Typography>
						<TextField
							fullWidth
							multiline
							rows={4}
							rowsMax={12}
							variant="outlined"
							value={instructions}
							onChange={(e) => onInstructionsChange(e.target.value)}
							disabled={isExecuting}
							placeholder="Add optional instructions for the AI..." />
					</React.Fragment>
				)}
			</DialogContent>
			<DialogActions>
				<Button color="primary" variant="contained" onClick={onSubmit} disabled={isExecuting}>
					<AiSparkleIcon style={{ marginRight: 8 }} /> Go!
					{isExecuting ? <Spinner size={18} style={{ marginLeft: 10 }} /> : null}
				</Button>
				<Button onClick={onCancel} disabled={isExecuting}>
					Cancel
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default OptimizeRecipeModal;
